import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const EventTypeFilter = ({
    eventTypes = [],
    loading = false,
    filters,
    restoreFilterValues,
    fieldName = 'eventType',
    onChangeValue = null,
}) => (
    <Field
        className='--minimalWidth --eventType'
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        name={fieldName}
        placeholder='Event type'
        onChangeValue={onChangeValue}
        options={eventTypes}
        selection
        search
        setValue={restoreFilterValues(filters, fieldName)}
    />
);

EventTypeFilter.propTypes = {
    eventTypes: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    fieldName: PropTypes.string,
    onChangeValue: PropTypes.func,
};
